import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ReactQuill from 'react-quill';
import '../../App.css';

function PostEditor() {
  const [formData, setFormData] = useState({
    title: '',
    content: '',
    category: '',
    cover: null
  });
  const [isDraft, setIsDraft] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(true);
  
  const { id } = useParams();
  const navigate = useNavigate();
  const isEditMode = !!id;
  const apiUrl = process.env.REACT_APP_API_URL ;
  const uploadUrl=process.env.REACT_APP_FOR_UPLOADS_URL
  useEffect(() => {
    // Check if user is logged in and is admin
    const token = localStorage.getItem('authToken');
    const user = JSON.parse(localStorage.getItem('user'));
    
    if (!token || !user) {
      navigate('/');
      return;
    }

    if (user.role !== 'admin') {
      navigate('/');
      return;
    }
    
    setLoading(false);
  }, [navigate]);

  useEffect(() => {
    if (id) {
fetch(`${apiUrl}/api/posts/${id}`)
        .then(res => res.json())
        .then(data => {
          setFormData({
            title: data.title,
            content: data.content,
            category: data.category || '',
            cover: null
          });
        });
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    
    try {
        const data = new FormData();
        data.append('title', formData.title);
        data.append('content', formData.content);
        data.append('category', formData.category);
        data.append('isDraft', isDraft);

        if (formData.cover) {
            data.append('cover', formData.cover);
        }

        const method = id ? 'PUT' : 'POST';
      const url = id
  ? `${apiUrl}/api/posts/${id}`
  : `${apiUrl}/api/posts`;

        
        // Get the auth token from localStorage
        const token = localStorage.getItem('authToken');

        if (!token) {
            setError('No authentication token found. Please login again.');
            return;
        }

        const response = await fetch(url, {
            method,
            headers: {
                'Authorization': `Bearer ${token}`,
            },
            body: data,
        });

        
        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || `HTTP ${response.status}: ${response.statusText}`);
        }

        const result = await response.json();
        navigate('/admin');
        
    } catch (err) {
        console.error('Post submit error:', err);
        setError(err.message || 'Failed to submit post');
    } finally {
        setIsSubmitting(false);
    }
  };

  return (
    <div className="blog-container">
      <h1>{id ? 'Edit Post' : 'Create Post'}</h1>
      <form onSubmit={handleSubmit} className="blog-form">
        <input
          type="text"
          placeholder="Post Title"
          value={formData.title}
          onChange={e => setFormData(prev => ({ ...prev, title: e.target.value }))}
          required
        />
        <input
          type="text"
          placeholder="Category"
          value={formData.category}
          onChange={e => setFormData(prev => ({ ...prev, category: e.target.value }))}
        />
        <input
          type="file"
          onChange={e => setFormData(prev => ({ ...prev, cover: e.target.files[0] }))}
        />
        <ReactQuill
          value={formData.content}
          onChange={value => setFormData(prev => ({ ...prev, content: value }))}
          theme="snow"
          className="post-editor-quill"
        />
        <div className="form-actions">

  <button type="submit" onClick={() => setIsDraft(true)}>
    Save as Draft
  </button>
  <button type="submit" onClick={() => setIsDraft(false)}>
    Publish
  </button>
</div>


      </form>
    </div>
  );
}

export default PostEditor;